import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditFDConfigContext from 'contexts/EditFDConfigContext';
import FDConfigForm from 'forms/FDConfigForm';

export default (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { selectedFDConfig } = React.useContext(EditFDConfigContext);
  if (!selectedFDConfig) return <></>;
  return (
    <div>
      <FDConfigForm config={selectedFDConfig} />
      <Box display="flex" justifyContent="center" width={1}>
        <Button className="btn-50" variant="contained" color="secondary" onClick={() => history.go(-1)}>
          {t('go-back')}
        </Button>
      </Box>
    </div>
  );
};
